export const getBuildById = (state, id) => state.builds[id]
export const getUserCurrency = (state, id) => state.builds[id].currency
